export function truncateWithEllipses(text, max) {
  return text.toString().substring(0, max-1) + (text.length > max ? '...' : '')
}
